const userStyle = {
	image: {
		display: "block",
		maxWidth: "95%",
		maxHeight: 600,
		margin: "auto",
		padding: 0,
	},
	modalImage: {
		display: "block",
		maxWidth: "95%",
		maxHeight: 400,
		margin: "auto",
		padding: 0,
	},
};

export default userStyle;
